import { darken, lighten } from '@mui/material/styles';
import { arcosDoradosTheme } from './arcosDoradosTheme';

const buildScale = (baseColor: string) => ({
  50: lighten(baseColor, 0.92),
  100: lighten(baseColor, 0.84),
  200: lighten(baseColor, 0.68),
  300: lighten(baseColor, 0.48),
  400: lighten(baseColor, 0.24),
  500: baseColor,
  600: darken(baseColor, 0.1),
  700: darken(baseColor, 0.2),
  800: darken(baseColor, 0.3),
  900: darken(baseColor, 0.4),
});

export const paletteBaseTokens = {
  brand: {
    primary: buildScale(arcosDoradosTheme.colors.primary),
    secondary: buildScale(arcosDoradosTheme.colors.secondary),
    gold: buildScale(arcosDoradosTheme.colors.secondary),
    red: buildScale(arcosDoradosTheme.colors.tomato),
    bordeaux: buildScale(arcosDoradosTheme.colors.bordeaux),
    purple: buildScale(arcosDoradosTheme.colors.purple),
    teal: buildScale(arcosDoradosTheme.colors.teal),
    cyan: buildScale(arcosDoradosTheme.colors.cyan),
    brown: buildScale(arcosDoradosTheme.colors.brown),
  },
  neutral: {
    0: '#ffffff',
    50: '#f8fafc',
    100: '#f6f7fb',
    200: '#edf2f7',
    300: '#d0d7e2',
    400: '#98a2b3',
    500: '#667085',
    600: '#475467',
    700: '#344054',
    800: '#1f2937',
    900: '#101828',
    1000: '#000000',
  },
  surfaces: {
    darkBackground: arcosDoradosTheme.colors.darkGray,
    darkPaper: arcosDoradosTheme.colors.dark,
    darkDialogActions: darken(arcosDoradosTheme.colors.darkGray, 0.12),
  },
  success: {
    500: arcosDoradosTheme.colors.success,
    700: darken(arcosDoradosTheme.colors.success, 0.2),
  },
  error: {
    500: arcosDoradosTheme.colors.tomato,
    700: darken(arcosDoradosTheme.colors.tomato, 0.2),
  },
  warning: {
    500: arcosDoradosTheme.colors.warning,
    700: darken(arcosDoradosTheme.colors.warning, 0.2),
  },
  info: {
    500: arcosDoradosTheme.colors.teal,
    700: darken(arcosDoradosTheme.colors.teal, 0.2),
  },
} as const;
